import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "var(--snackbar-icon-success-bg, #E6FFE4)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2 10.5H22.6V22.6H7.2V10.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 27C22.0753 27 27 22.0753 27 16C27 9.9247 22.0753 5 16 5C9.9247 5 5 9.9247 5 16C5 22.0753 9.9247 27 16 27ZM19.8896 12.1104C20.0962 11.9041 20.3762 11.7884 20.6681 11.7886C20.96 11.7888 21.2398 11.9049 21.4461 12.1115C21.6524 12.3181 21.7681 12.5981 21.7679 12.89C21.7677 13.1819 21.6516 13.4617 21.445 13.668L15.2223 19.8907C15.1204 19.9932 14.9992 20.0745 14.8657 20.1301C14.7323 20.1856 14.5891 20.2141 14.4446 20.2141C14.3001 20.2141 14.1569 20.1856 14.0235 20.1301C13.89 20.0745 13.7688 19.9932 13.6669 19.8907L10.555 16.7788C10.4499 16.6773 10.3661 16.5559 10.3085 16.4217C10.2508 16.2875 10.2205 16.1432 10.2192 15.9971C10.218 15.8511 10.2458 15.7062 10.3011 15.5711C10.3564 15.4359 10.4381 15.313 10.5414 15.2098C10.6446 15.1065 10.7675 15.0248 10.9027 14.9695C11.0378 14.9142 11.1827 14.8864 11.3287 14.8876C11.4748 14.8889 11.6191 14.9192 11.7533 14.9769C11.8875 15.0345 12.0089 15.1183 12.1104 15.2234L14.4446 17.5565L19.8896 12.1115V12.1104Z",
			fill: "var(--snackbar-icon-success-color, #187F16)"
		})
	]
});
export default SvgSuccess;
